import { render, staticRenderFns } from "./uf_is_strategically_medicines.vue?vue&type=template&id=520d4f0a&scoped=true"
import script from "./uf_is_strategically_medicines.vue?vue&type=script&lang=js"
export * from "./uf_is_strategically_medicines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520d4f0a",
  null
  
)

export default component.exports